import 'common/types';
// import scss
import 'scss/app.scss';
import Vue from 'vue';
import router from 'common/router';
// import store from 'v-store/index';
import VueCompositionApi from '@vue/composition-api';
import App from 'v-component/page/app.vue';
import {Style, Toast} from '@mfex/mai-ui';
import MSentry from '@mfex/mfex-sentry-vue';
import {BackendResult} from 'common/util';

Vue.use(VueCompositionApi);
Vue.use(Style);
Vue.use(Toast);

MSentry.init({
    VueRouter: router,
    Vue,
    dsn: 'https://8c641a90e8b648de992b8d677e67f931@sentry.corp.mama.cn/5',
    release: `${process.env.PROJECT_PKG_NAME}@${process.env.DEPLOY_TAG}`
});

BackendResult.setErrorHooks(e => {
    MSentry.captureException(e);
});

export const eventBus = new Vue({
    data() {
        return {
            tagsList: [{id: ''}]
        };
    }
});

new Vue({
    render(h) {
        return h(App);
    },
    router,
    // store,
    mounted() {
        const image = document.getElementById('index-image');
        image.parentNode.removeChild(image);
    }
}).$mount('#app');
